// App/AdminPortal/features/Settings/index.js
import { Tabs, Typography } from "antd";
import React, { lazy, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import AdminAppLayout from "../../Layouts/AdminLayout";
import GlobalImages from "./GlobalImages";
import PointsCalculation from "./PointsCalculation";
import { colors } from "../../utils/colors";

const { Title } = Typography;

const PointsTransferPage = lazy(() => import("./PointsTransfer/PointsTransferPage"));

const Settings = () => {
  // Use search params to keep tab state in URL
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "1";

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  const items = [
    {
      key: "1",
      label: `Global Images`,
      children: <GlobalImages />,
    },
    {
      key: "2",
      label: `Points Calculation`,
      children: <PointsCalculation />,
    },
    {
      key: "3",
      label: `Points Transfer`,
      // Only visible to admin users; admin check is handled at the route level
      children: (
        <Suspense fallback={<div>Loading...</div>}>
          <PointsTransferPage />
        </Suspense>
      ),
    },
  ];

  return (
    <AdminAppLayout>
      <div
        style={{
          paddingLeft: 60,
          paddingRight: 60,
          marginTop: 56,
        }}
      >
        <Title level={4} style={{ color: colors.black, marginBottom: 24 }}>
          Settings
        </Title>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={items}
        />
      </div>
    </AdminAppLayout>
  );
};

export default Settings;
